










import { Vue, Component } from 'vue-property-decorator';
import NuevaSolicitud from '@/pantallas/SucursalVirtual/NuevaSolicitud/NuevaSolicitud.vue';

@Component({
  components: { NuevaSolicitud },
})
export default class NuevaSolicitudPantalla extends Vue {}
